module.exports = __webpack_public_path__ + "../resources/images/illustration_task-f422453ddcaeda6536c6de47e4c88152.svg";